import { render, staticRenderFns } from "./CardSkeletonLoader.vue?vue&type=template&id=c70a56de&"
import script from "./CardSkeletonLoader.vue?vue&type=script&lang=ts&"
export * from "./CardSkeletonLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports